var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTumbler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#314358"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2344 13.4516C10.5035 13.4516 9.78964 13.4516 9.00461 13.4516C9.00461 12.4949 8.9866 11.607 9.02177 10.7216C9.02778 10.568 9.2294 10.3552 9.39155 10.2849C11.8659 9.19868 13.0404 7.18678 13.5046 4.63522C13.5466 4.40357 13.8203 4.04752 14.0039 4.03637C15.0103 3.97717 16.0227 4.00805 17.1157 4.00805C17.1157 5.97964 17.1157 7.89545 17.1157 9.90478C18.7004 9.90478 20.2035 9.90478 21.747 9.90478C21.747 11.1196 21.747 12.241 21.747 13.4396C20.2378 13.4396 18.7536 13.4396 17.3302 13.4396C17.2401 13.5511 17.1861 13.5871 17.1861 13.6232C17.1758 16.0838 17.1243 18.5461 17.1835 21.0059C17.2135 22.2542 18.0423 22.9234 19.2992 22.8668C19.917 22.8385 20.5295 22.6926 21.2519 22.5845C21.5857 23.5746 21.9752 24.6041 22.248 25.6646C22.2943 25.8447 21.8868 26.2497 21.608 26.3878C19.8337 27.2707 17.9668 27.4448 16.051 26.9506C13.176 26.2094 11.34 23.8397 11.3271 20.8729C11.3168 18.4835 11.3194 16.0941 11.3134 13.7038C11.3151 13.6583 11.2876 13.6137 11.2344 13.4516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTumbler);
export default __webpack_public_path__ + "static/media/icon-tumbler.6bdfd6d426f21a4946b1e8df871c095a.svg";
export { ForwardRef as ReactComponent };